/* eslint-disable react/jsx-key */
import { lazy } from 'react';

import Tracker from 'components/Tracker';
import LandingPage from 'pages/LandingPage';
import SmsProvider from 'providers/Sms';

// const CategoryCarousel = lazy(() => import('../pages/CategoryCarousel'));
// const CategoryList = lazy(() => import('../pages/CategoryList'));
// const Product = lazy(() => import('../pages/Product'));
// const ContentPage = lazy(() => import('../pages/ContentPage'));
// const ContentCategory = lazy(() => import('../pages/ContentCategory'));
// const Carts = lazy(() => import('../pages/Carts'));
const Login = lazy(() => import('../pages/Login'));
// const OrderFormAndConfrim = lazy(() => import('../pages/OrderFormAndConfrim'));
// const OrderSuccess = lazy(() => import('../pages/OrderSuccess'));
// const MyAccount = lazy(() => import('../pages/MyAccount'));
// const OrderDetail = lazy(() => import('../pages/OrderDetail'));

// the childrenKey, idKey and itemKey inTracker are refer to shop
const routes = (basename = '') => [
  {
    key: 'landing-page',
    path: basename,
    exact: true,
    element: <LandingPage />,
    displayMenu: false,
    name: '',
  },
  {
    key: 'login',
    path: basename + '/login',
    exact: true,
    element: (
      <Tracker.WithTracker ga="login">
        <SmsProvider>
          <Login />
        </SmsProvider>
      </Tracker.WithTracker>
    ),
    displayMenu: false,
    name: '登入',
  },
  // {
  //   key: 'categories',
  //   path: basename + '/categories',
  //   element: (
  //     <Tracker.WithTracker ga="categories">
  //       <CategoryCarousel />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: true,
  //   name: <IntlMessage id="product_introduce" />,
  // },
  // {
  //   key: 'category',
  //   path: basename + '/category/:categoryId',
  //   element: (
  //     <Tracker.WithIdTracker
  //       ga="category"
  //       idKey="categoryId"
  //       itemKey="categories"
  //     >
  //       <CategoryList />
  //     </Tracker.WithIdTracker>
  //   ),
  //   displayMenu: true,
  //   getTitle: (title) => {
  //     const { categoryName } = getCategoryTitle(title);
  //     return categoryName;
  //   },
  //   children: {
  //     path: ({ id }) => `/category/${id}`,
  //     key: 'categories',
  //   },
  //   name: <IntlMessage id="sample" />,
  // },
  // {
  //   key: 'product',
  //   path: basename + '/product/:productId',
  //   element: (
  //     <Tracker.WithProductTracker
  //       ga="view_item_liff"
  //       idKey="productId"
  //       itemKey="products"
  //     >
  //       <Tracker.WithIdTracker
  //         ga="product"
  //         idKey="productId"
  //         itemKey="products"
  //         getPage={(shopId, lineId, product) => {
  //           return `/shop/${shopId}/user/${lineId}/action/product/${product.id}`;
  //         }}
  //         getTitle={(shopId, lineId, product) => {
  //           return `product/${product.name}:${product.product_uid}`;
  //         }}
  //       >
  //         <ImageModalProvider>
  //           <Product />
  //         </ImageModalProvider>
  //       </Tracker.WithIdTracker>
  //     </Tracker.WithProductTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'content-page',
  //   path: basename + '/content-page/:contentPageId',
  //   element: (
  //     <Tracker.WithIdTracker
  //       ga="content-page"
  //       idKey="contentPageId"
  //       itemKey="contentPages"
  //       getPage={(shopId, lineId, page) => {
  //         return `/shop/${shopId}/user/${lineId}/action/content-page/${page.id}`;
  //       }}
  //       getTitle={(shopId, lineId, page) => {
  //         return `content-page/${page.title}`;
  //       }}
  //     >
  //       <ContentPage />
  //     </Tracker.WithIdTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'content-category',
  //   path: basename + '/content-category/:categorySlug',
  //   element: (
  //     <Tracker.WithTracker ga="content-category">
  //       <ContentCategory />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: true,
  //   children: {
  //     path: ({ slug }) => `/content-category/${slug}`,
  //     key: 'contentCategories',
  //   },
  //   name: <IntlMessage id="content_hub" />,
  // },
  // {
  //   key: 'carts',
  //   path: basename + '/carts',
  //   element: (
  //     <Tracker.WithTracker ga="carts">
  //       <Carts />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'order-form',
  //   path: basename + '/order-form',
  //   element: (
  //     <Tracker.WithTracker ga="order-form">
  //       <OrderFormAndConfrim />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'order-success',
  //   path: basename + '/order-success/:orderId',
  //   element: (
  //     <Tracker.WithTracker ga="order-success">
  //       <OrderSuccess />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'order-detail',
  //   path: basename + '/order-detail/:orderId',
  //   element: (
  //     <Tracker.WithTracker ga="order-detail">
  //       <OrderDetail />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
  // {
  //   key: 'my-account',
  //   path: basename + '/my-account',
  //   element: (
  //     <Tracker.WithTracker ga="my-account">
  //       <MyAccount />
  //     </Tracker.WithTracker>
  //   ),
  //   displayMenu: false,
  //   name: '',
  // },
];

export default routes;
